/* External dependencies */
import { Observable } from 'rxjs';
import { filter, switchMap } from 'rxjs/operators';

/* Local dependencies */
import { getClient } from '../../../clients/client';
import { signedUrlsError, signedUrlsSuccess } from './action';
import { getSignedUrlsQuery } from './queries';
import { GetSingleSignedUrlsInput, SignedUrlAction, SignedUrlTypes } from './type';

export default function signedUrlEpic(action$: Observable<SignedUrlAction>) {
  return action$.pipe(
    filter((action: SignedUrlAction) => action.type === SignedUrlTypes.SIGNED_URLS_REQUEST),
    switchMap((action: SignedUrlAction) => getSignedUrls(action.input).catch(signedUrlsError)),
  );
}

async function getSignedUrls(input: GetSingleSignedUrlsInput) {
  const graphQLClient = await getClient();

  const {
    data: {
      getSignedUrls: { signedUrls },
    },
  } = await graphQLClient.query({
    query: getSignedUrlsQuery,
    variables: {
      input,
    },
  });

  return signedUrlsSuccess(signedUrls);
}
